<template>
  <span
    class="input-help"
    v-text="text"
  />
</template>

<script>
  export default {
    props: {
      text: {
        type: String,
        default: null
      }
    }
  };
</script>

<style lang="scss">
  @import "../../styles/shared/shared";

  .input-help {
    font-size: 80%;
    color: $guardsman;
  }
</style>
